import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Facebook() {
    return (
        <>
            <Header />
            <div class="insidecrypto-div">

                <div class="insidecrypto-div-sub">
                    <iframe src='https://widgets.sociablekit.com/facebook-group-posts/iframe/25573715' frameborder='0' width='100%' height='1000'></iframe>
                </div>
            </div>

            <Footer />
        </>
    )
}